var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccept(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 30,
    viewBox: "0 0 101 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100.434,
    height: 30,
    rx: 4,
    fill: "#2283F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.0654 14.2173C41.6482 13.8554 41.0167 13.9002 40.6548 14.3174C40.2929 14.7346 40.3377 15.3661 40.7549 15.728L42.0654 14.2173ZM40.7549 15.728L47.82 21.8569L49.1306 20.3461L42.0654 14.2173L40.7549 15.728Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6708 9.66709C59.0392 9.25565 59.0043 8.62344 58.5929 8.25502C58.1814 7.8866 57.5492 7.92147 57.1808 8.33291L58.6708 9.66709ZM57.1808 8.33291L46.2222 20.5711L47.7121 21.9053L58.6708 9.66709L57.1808 8.33291Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccept);
export default __webpack_public_path__ + "static/media/accept.9900beec2925c0d01fe755ecad0bfabf.svg";
export { ForwardRef as ReactComponent };